module.exports = __webpack_public_path__ + "img/zyyhpz-w.079e8460.svg";